$(function () {
  let section = $('.pedido-detalle')
  if (section.get(0) == null) {
    return
  }
  let vueApp = new Vue({
    el: section.get(0),
    data: {

    },
    mounted() {
      this.validar()
    },
    methods: {
      validar(){
        if($('#stripe-confirmar')[0] == null){
          return
        }
        this.$nextTick(() => {
          $('#stripe-confirmar').validarForm((form) => {
            vueApp.confirmarCuenta()
          })
        })
      },
      confirmarCuenta(){
        $("#btnConfirmar").loader("show")
        let $formData = new FormData(document.querySelector("#stripe-confirmar"))
        axios
          .post("/confirmar-cuenta-stripe", $formData)
          .then((respuesta) => {
            $("#btnConfirmar").loader("hide")
            if (respuesta.data.error) {
              swal(respuesta.data.error, "", "info").finally(() => {
                if(respuesta.data.reload){
                  location.reload()
                }
              })
              return
            }
            $("#btnConfirmar").loader("show")
            location.reload()
          })
          .catch((error) => {
            $("#btnConfirmar").loader("hide")
            swal("Ocurrió un error inesperado", "", "info")
            console.error(error)
          })
      },
    }
  });



});
